<template>
  <div class="upload-report-container">
    <el-card class="upload-card">
      <div class="page-header">
        <h2>上传其他附件</h2>
        <div class="header-actions">
          <el-button @click="$router.back()">返回</el-button>
        </div>
      </div>

      <!-- 表单内容 -->
      <div class="form-content">
        <el-form ref="uploadForm" :model="form" label-width="120px" label-position="right">
          <el-divider content-position="left">
            <span class="divider-title">订单基本信息</span>
          </el-divider>
          
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="项目名称">
                <el-input v-model="form.projectName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单号">
                <el-input v-model="form.orderNo" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="商家名称">
                <el-input v-model="form.merchantName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户名称">
                <el-input v-model="form.customerName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 仪器信息和型号 -->
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="仪器信息">
                <el-input v-model="form.deviceInfo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="仪器型号">
                <el-input v-model="form.deviceModel" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="样品数量">
                <el-input v-model="form.sampleCount" disabled>
                  <template slot="append">个</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单状态">
                <el-input v-model="form.status" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 测试要求附件 -->
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="测试要求附件">
                <div v-if="form.requirementFiles && form.requirementFiles.length > 0" class="file-list-container">
                  <el-table
                    :data="form.requirementFiles"
                    style="width: 100%"
                    border>
                    <el-table-column
                      prop="name"
                      label="文件名"
                      min-width="300">
                      <template slot-scope="scope">
                        {{ scope.row.name || scope.row.fileName || '未命名文件' }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="size"
                      label="大小"
                      width="150">
                      <template slot-scope="scope">
                        {{ formatFileSize(scope.row.size) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="150"
                      align="center">
                      <template slot-scope="scope">
                        <el-button 
                          type="text" 
                          size="small" 
                          @click="handlePreview(scope.row)">预览</el-button>
                        <el-button 
                          type="text" 
                          size="small" 
                          @click="handleDownload(scope.row)" 
                          style="margin-left: 10px;">下载</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-else class="no-file">
                  <el-empty description="暂无测试要求附件" :image-size="60"></el-empty>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 测试结果附件 -->
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="测试结果附件">
                <div v-if="form.resultFiles && form.resultFiles.length > 0" class="file-list-container">
                  <el-table
                    :data="form.resultFiles"
                    style="width: 100%"
                    border>
                    <el-table-column
                      prop="name"
                      label="文件名"
                      min-width="300">
                      <template slot-scope="scope">
                        {{ scope.row.name || scope.row.fileName || '未命名文件' }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="size"
                      label="大小"
                      width="150">
                      <template slot-scope="scope">
                        {{ formatFileSize(scope.row.size) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="150"
                      align="center">
                      <template slot-scope="scope">
                        <el-button 
                          type="text" 
                          size="small" 
                          @click="handlePreview(scope.row)">预览</el-button>
                        <el-button 
                          type="text" 
                          size="small" 
                          @click="handleDownload(scope.row)" 
                          style="margin-left: 10px;">下载</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-else class="no-file">
                  <el-empty description="暂无测试结果附件" :image-size="60"></el-empty>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 上传发票/清单/报告/合同/其他附件 -->
          <el-divider content-position="left">
            <span class="divider-title">上传发票/清单/报告/合同/其他附件</span>
          </el-divider>
          
          <el-form-item label="附件上传" prop="reportFileList">
            <el-upload
              class="upload-demo"
              action="#"
              :http-request="handleReportUpload"
              :file-list="[]"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              drag
              multiple
              :limit="5"
              :show-file-list="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">
                上传发票、合同、测试报告、清单等文件，支持PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)等格式
              </div>
            </el-upload>
            
            <!-- 使用表格显示已上传文件 -->
            <div v-if="reportForm.fileList && reportForm.fileList.length > 0" class="uploaded-files">
              <h3 class="file-list-title">已上传文件</h3>
              <el-table
                :data="reportForm.fileList"
                style="width: 100%; margin-top: 15px;"
                border>
                <el-table-column
                  prop="name"
                  label="文件名"
                  min-width="300">
                </el-table-column>
                <el-table-column
                  prop="size"
                  label="大小"
                  width="150">
                  <template slot-scope="scope">
                    {{ formatFileSize(scope.row.size) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="180"
                  align="center">
                  <template slot-scope="scope">
                    <el-button 
                      type="text" 
                      size="small" 
                      @click="handlePreview(scope.row)">预览</el-button>
                    <el-button 
                      type="text" 
                      size="small" 
                      @click="handleDownload(scope.row)" 
                      style="margin-left: 10px;">下载</el-button>
                    <el-button 
                      type="text" 
                      size="small"
                      style="color: #F56C6C; margin-left: 10px;"
                      @click="handleRemoveReportFile(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表单操作按钮 -->
      <div class="form-actions">
        <el-button @click="$router.back()">取消</el-button>
        <el-button type="primary" @click="submitReports" :loading="loading">提交</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'UploadReports',
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      uploadingFiles: 0,
      form: {
        id: '',
        projectName: '',
        orderNo: '',
        merchantName: '',
        customerName: '',
        deviceInfo: '',
        deviceModel: '',
        sampleCount: '',
        status: '',
        resultFiles: [],
        requirementFiles: []
      },
      reportForm: {
        fileList: []
      },
      checklistForm: {
        fileList: []
      }
    }
  },
  created() {
    const orderId = this.orderId || this.$route.params.id
    if (orderId) {
      this.fetchOrderDetail(orderId)
    } else {
      this.$message.error('缺少订单ID，无法获取订单详情')
    }
  },
  methods: {
    async fetchOrderDetail(orderId) {
      this.loading = true
      try {
        const res = await adminApi.getOrderById(orderId)
        if (res) {
          console.log('获取到的订单数据:', res)
          console.log('orderRequirementFile字段:', res.orderRequirementFile || res.orderFile)
          
          const orderData = res
          
          // 处理订单要求附件，可能在不同字段
          let requirementFiles = []
          if (Array.isArray(orderData.orderRequirementFile)) {
            console.log('使用orderRequirementFile字段')
            requirementFiles = orderData.orderRequirementFile
          } else if (Array.isArray(orderData.orderFile)) {
            console.log('使用orderFile字段')
            requirementFiles = orderData.orderFile
          }
          console.log('处理后的requirementFiles:', requirementFiles)
          
          this.form = {
            id: orderId,
            projectName: orderData.projectName || '',
            orderNo: orderData.orderSn || '',
            merchantName: orderData.merchantName || '',
            customerName: orderData.customerName || '',
            deviceInfo: orderData.deviceName || '',
            deviceModel: orderData.deviceModel || '',
            sampleCount: orderData.testCount || 1,
            status: this.getStatusText(orderData.orderStatus) || '已测试',
            resultFiles: Array.isArray(orderData.orderResultFile) ? orderData.orderResultFile.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              url: file.fileUrl || file.url || '',
              fileId: file.fileId || file.id
            })) : [],
            requirementFiles: requirementFiles.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              url: file.fileUrl || file.url || '',
              fileId: file.fileId || file.id
            }))
          }
          
          console.log('处理后的表单数据:', this.form);
          console.log('测试要求附件:', this.form.requirementFiles);
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    
    async submitReports() {
      // 验证是否上传了附件
      if (this.reportForm.fileList.length === 0) {
        this.$message.warning('请至少上传一个附件')
        return
      }
      
      if (this.uploadingFiles > 0) {
        this.$message.warning(`还有 ${this.uploadingFiles} 个文件正在上传，请等待上传完成后再提交`)
        return
      }

      this.loading = true
      try {
        const params = {
          id: this.form.id,
          orderTestReportFileList: this.reportForm.fileList.map(file => ({
            fileId: file.name,
            filePath: file.path,
            fileName: file.fileId,
            fileUrl: file.url,
            fileSize: file.size
          })),
          orderTestCheckFileList: []
        }
        
        const res = await adminApi.uploadReports(params)
        if (res) {
          this.$message.success('附件上传成功')
          
          // 获取跳转路径
          const userRole = localStorage.getItem('userRole')
          let basePath = '/admin'
          
          if (userRole === 'merchant') {
            basePath = '/merchant'
          } else if (userRole === 'customer') {
            basePath = '/customer'
          }
          
          // 使用window.location直接跳转，而不是router.push
          console.log('准备跳转到:', `${basePath}/orders/tested`)
          setTimeout(() => {
            window.location.href = `${basePath}/orders/tested`
          }, 1500)
        } else {
          this.$message.error('上传失败，请重试')
        }
      } catch (error) {
        console.error('提交附件失败:', error)
        this.$message.error('提交失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + ' MB'
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
      }
    },
    
    async handleReportUpload(options) {
      const { file } = options
      
      this.uploadingFiles++
      
      try {
        const res = await adminApi.uploadFile(file, '', (percent) => {
          console.log(`上传进度: ${parseInt(percent)}%`)
        })
        
        if (res) {
          const fileData = res
          const newFile = {
            name: fileData.fileId,
            size: file.size,
            uploadTime: new Date(),
            url: fileData.url || fileData.fileUrl,
            fileId: fileData.fileId || fileData.id,
            path: fileData.path || '',
            status: 'success'
          }
          
          this.reportForm.fileList.push(newFile)
          this.$message.success(`附件 ${file.name} 上传成功`)
        } else {
          this.$message.error(`附件 ${file.name} 上传失败，请重试`)
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error(`附件 ${file.name} 上传失败: ${error.message || '未知错误'}`)
      } finally {
        this.uploadingFiles--
      }
    },
    
    handleRemove(file) {
      console.log('移除文件', file)
    },
    
    handleRemoveReportFile(index) {
      this.reportForm.fileList.splice(index, 1)
    },
    
    beforeUpload(file) {
      // 检查文件大小
      const isLt200M = file.size / 1024 / 1024 < 200
      if (!isLt200M) {
        this.$message.error('文件大小不能超过200MB!')
        return false
      }
      
      // 检查文件类型
      const allowedTypes = [
        'application/pdf', 
        'application/msword', 
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/zip',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/octet-stream',
        'application/x-7z-compressed'
      ]
      
      // 获取文件扩展名
      const fileName = file.name
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
      const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'zip', 'rar', '7z']
      
      // 同时检查MIME类型和文件扩展名
      const isAllowedType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension)
      
      if (!isAllowedType) {
        this.$message.warning('请上传PDF、Word、Excel、图片或压缩包(ZIP/RAR/7Z)格式的文件')
        console.log('文件类型不允许:', file.type, fileExtension)
        return false
      }
      
      return true
    },
    
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    
    goToOrderDetail() {
      if (this.$route.path.includes('management')) {
        // 在OrderManagement中显示时，跳转到对应的详情页面
        const userRole = localStorage.getItem('userRole')
        let basePath = '/admin'
        
        if (userRole === 'merchant') {
          basePath = '/merchant'
        } else if (userRole === 'customer') {
          basePath = '/customer'
        }
        
        this.$router.push(`${basePath}/orders/detail/${this.form.id}`)
      } else {
        // 直接在报告上传页面打开时
        this.$router.push(`/admin/orders/detail/${this.form.id}`)
      }
    },
    
    getStatusText(status) {
      const statusTextMap = {
        'NOT_SHIPPED': '未邮寄',
        'IN_TRANSIT': '在途',
        'TESTING': '测试中',
        'TESTED': '已测试',
        'DISPUTE': '复测/争议',
        'RETURN': '回寄',
        'FORWARD': '转寄',
        'UNSETTLED': '未结算',
        'COMPLETED': '已完成',
        'CANCEL': '已取消'
      }
      return statusTextMap[status] || status
    }
  }
}
</script>

<style scoped>
.upload-report-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.upload-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
}

.form-content {
  margin: 30px 0;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.file-list-container {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.no-file {
  padding: 15px 0;
  text-align: center;
}

.uploaded-files {
  margin-top: 20px;
}

.uploaded-files .file-list-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #606266;
}

.uploaded-files .el-table {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.el-upload {
  width: 100%;
}

.el-upload-dragger {
  width: 100%;
}

.el-upload__tip {
  line-height: 1.5;
  margin-top: 10px;
  color: #909399;
}
</style> 